<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Histórico de cargas')"
      icono="mdi-archive"
      tabla="hissolcar"
      :campos="['id_solcar-', 'id_ins', 'id_car', 'ideproapa-', 'numproapa', 'mat', 'id_estsolcar', 'actcar-', 'tra', 'inicar', 'descar-', 'fincar', 'kwhcar', 'coscar', 'codfacpag']"
      :campos-filtrables="['id_ins', 'id_car', 'id_estsolcar', 'inicar', 'fincar']"
      busqueda-rapida
      :permitir-eliminar="permisoEscritura"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gescar");
    }
  },
};
</script>

<style>
</style>